// MODULES
import React from "react";

// HELPERS
import {createClassName, getPropertiesByPrefix, parseDraftDataPropsToFieldState, delay} from "@helpers/utils";
import fulfillmentCheck from "./Advice.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import OptionsList from "../../../components/OptionsList/OptionsList";
import EditableField from "../../../components/EditableField/EditableField";
import TextView from "../../../../../components/TextView/TextView";
import NumberField from "../../../components/NumberField/NumberField";


export default class Advice extends React.PureComponent {
	static companyExclusive = false;
	static privateExclusive = false;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState)
	{
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields)
		{
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}

		if (prevProps.draftData !== props.draftData)
		{
			if (props.draftData)
			{
				// get the draftData props specific to this section only
				const draftDataProps = getPropertiesByPrefix(
					props.draftData,
					["advice_", "customer_", "allocation_fee", "checkbox_"]
				);
				// parse the draftData props into state.fields
				const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);

				this.setState(
					{
						fields: {
							...newFieldsState
						}
					},
					async () =>
					{
						await delay(200);
						onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
					}
				);
			}
		}
	}

	render() {
		const {props, state} = this;
		const {title} = props;

		const classes = createClassName("Cob-Fees", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<p style={{margin: "0 0 10px 0"}}>
						Vilket placeringsråd har givits till kunden?
					</p>

					<EditableField
						name="advice_customer_investment"
						Component={TextView}
						maxLength={570}
						disableEnterKey={true}
						label={`${570 - state.fields.advice_customer_investment.length} tecken kvar`}
						value={state.fields.advice_customer_investment}
						valid={
							state.fields.advice_customer_investment.length > 0 &&
							state.fields.advice_customer_investment.length <= 570 ? true : ""
						}
						resize="vertical"
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>

					<p style={{margin: "20px 0 10px 0"}}>
						Belopp att placera
					</p>

					<div style={{maxWidth: "150px"}}>
						<EditableField
							Component={NumberField}
							name="customer_amount_investment"
							label="Ange"
							value={state.fields.customer_amount_investment}
							valid={state.validFields.customer_amount_investment}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							unit={"kr"}
						/>
					</div>

					<h4 style={{margin: "40px 0 0 0"}}>Varför har just detta placeringsråd givits?</h4>
					<p style={{margin: "10px 0"}}>
						Motivering till varför detta råd har givits till kunden, hur uppfyller rådet kundens syfte och
						behov med placeringen? Hur är rådet förenligt med kundens risktolerans och förmåga att bära
						förluster?
					</p>

					<EditableField
						name="advice_customer_investment_motivation"
						Component={TextView}
						disableEnterKey={true}
						label={`${1000 - state.fields.advice_customer_investment_motivation.length} tecken kvar`}
						value={state.fields.advice_customer_investment_motivation}
						maxLength={1000}
						valid={
							state.fields.advice_customer_investment_motivation.length > 0 &&
							state.fields.advice_customer_investment_motivation.length <= 1000 ? true : null
						}
						resize="vertical"
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Belåning / pantsättning av värdepappersportföljen kan komma att ske"}
						name="checkbox_advice_inv_loan"
						options={state.fields.checkbox_advice_inv_loan.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Kunden har förstått risken med föreslagen placering?"}
						name="checkbox_advice_suitability_knowledge_inv"
						options={state.fields.checkbox_advice_suitability_knowledge_inv.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.checkbox_advice_suitability_knowledge_inv.options[0].checked && (
						<p>
							<strong style={{color: "red"}}>Obs!</strong> Kunden måste göras medveten om risken som
							föreslagen placering innebär.
						</p>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Kunden har fått information om att rådgivningen som tillhandahållits inte är grundad på en opartisk och personlig analys"}
						name="checkbox_advice_suitability_non_personal"
						options={state.fields.checkbox_advice_suitability_non_personal.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.checkbox_advice_suitability_non_personal.options[0].checked && (
						<p>
							<strong style={{color: "red"}}>Obs!</strong> Kunden måste informeras om att rådgivningen som
							tillhandahållits inte är grundad på en opartisk och personlig analys.
						</p>
					)}

					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Kunden har fått information om eventuell emittentrisk i föreslagen lösning"}
						name="checkbox_advice_risc"
						options={state.fields.checkbox_advice_risc.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.checkbox_advice_risc.options[0].checked && (
						<p>
							<strong style={{color: "red"}}>Obs!</strong> Kunden måste informeras om eventuell
							emittentrisk i den föreslagna lösningen.
						</p>
					)}

					<p style={{margin: "40px 0 10px 0"}}>
						Priser och ersättningar
					</p>

					<EditableField
						name="allocation_fee"
						Component={TextView}
						disableEnterKey={true}
						label={`${570 - state.fields.allocation_fee.length} tecken kvar`}
						value={state.fields.allocation_fee}
						maxLength={570}
						valid={
							state.fields.allocation_fee.length > 0 &&
							state.fields.allocation_fee.length <= 570 ? true : null
						}
						resize="vertical"
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>



					<OptionsList
						type="radio"
						orientation="horizontal"
						description={"Är placeringsrådet en avrådan?"}
						name="checkbox_avradan"
						options={state.fields.checkbox_avradan.options}
						onChange={this._onOptionsListChange}
						style={{marginTop: "40px"}}
					/>

					{state.fields.checkbox_avradan.options[1].checked && (
						<React.Fragment>
							<p style={{margin: "40px 0 10px 0"}}>
								Om placeringsrådet är en avrådan, var god motivera
							</p>

							<EditableField
								name="advice_customer_adv_against_motivation"
								Component={TextView}
								disableEnterKey={true}
								label={`${570 - state.fields.advice_customer_adv_against_motivation.length} tecken kvar`}
								value={state.fields.advice_customer_adv_against_motivation}
								maxLength={570}
								valid={
									state.fields.advice_customer_adv_against_motivation.length > 0 &&
									state.fields.advice_customer_adv_against_motivation.length <= 570 ? true : null
								}
								resize="vertical"
								onChange={this._onFieldChange}
								onBlur={this._onFieldBlur}
							/>
						</React.Fragment>
					)}

					<p style={{margin: "40px 0 10px 0"}}>
						Övriga noteringar
					</p>

					<EditableField
						name="advice_notes_other"
						Component={TextView}
						disableEnterKey={true}
						label={`${1400 - state.fields.advice_notes_other.length} tecken kvar`}
						value={state.fields.advice_notes_other}
						maxLength={1400}
						valid={
							state.fields.advice_notes_other.length > 0 &&
							state.fields.advice_notes_other.length <= 1400 ? true : null
						}
						resize="vertical"
						onChange={this._onFieldChange}
						onBlur={this._onFieldBlur}
					/>
				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) => {
		return value.length > 0;
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onOptionsListChange = ({type, name}, option, index) => {
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions,
				},
			},
		}, () => fulfillmentCheck(this.props, this.state));
	};
}

function _getFields() {
	return [
		"advice_customer_investment",
		"customer_amount_investment",
		"advice_customer_investment_motivation",
		"advice_notes_other",
		"allocation_fee",
		"advice_customer_adv_against_motivation",
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};

	return {
		validFields: {},
		fields: {
			advice_customer_investment: "",
			customer_amount_investment: "",
			advice_customer_investment_motivation: "",
			advice_notes_other: "",
			allocation_fee: "",
			advice_customer_adv_against_motivation: "",

			checkbox_advice_suitability_knowledge_inv: {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},

			checkbox_advice_suitability_non_personal: {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},

			checkbox_advice_risc: {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},

			checkbox_advice_inv_loan: {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},

			checkbox_avradan: {
				options: [
					{label: "Nej", value: "no", checked: false},
					{label: "Ja", value: "yes", checked: false}
				]
			},
		}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Advice/Advice.js